import { defineComponent as q, getCurrentInstance as G, toRef as R, ref as r, computed as f, onMounted as _, onUpdated as K, watch as O } from "vue";
import { isEmpty as P, isEqual as w } from "lodash-es";
import { MsClose as W, MsArrowDown as j, MsDisabled as z, MsWarning as J } from "@sunrise/icons";
import { createUUID as Q } from "./index228.js";
import { addFormFieldErrorHandling as X } from "./index5.js";
import { AutocompleteDropdown as h } from "@sunrise/types";
const ne = q({
  name: "CsAutocompleteDropdown",
  components: {
    MsWarning: J,
    MsDisabled: z,
    MsArrowDown: j,
    MsClose: W
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: "",
      required: !0
    },
    autocomplete: String,
    suggestions: {
      type: Array,
      default: () => []
    },
    autoFocus: Boolean,
    errorMsg: String,
    isInactive: Boolean,
    showImmediately: {
      type: Boolean,
      default: !1
    },
    label: String,
    limit: Number,
    showSeparators: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputmode: {
      type: String
    }
  },
  emits: ["update:modelValue", "select", "highlighted", "select", "focus", "blur"],
  setup(t, { emit: n }) {
    var C;
    const i = (C = G()) == null ? void 0 : C.proxy, s = Q("input-");
    let g;
    const v = X(R(t, "errorMsg")), a = r(!1), c = r(null), l = r([0, 0]), A = f(() => t.modelValue !== ""), y = f(() => t.suggestions.filter((e) => !P(e.items))), E = f(
      () => T() && a.value && (t.modelValue !== "" || t.showImmediately)
    ), d = r(null), S = r([]), V = r("");
    _(() => {
      var e;
      t.autoFocus && ((e = c.value) == null || e.focus());
    });
    function M() {
      var e;
      clearTimeout(g), a.value = !0, (e = c.value) == null || e.select(), i == null || i.$emit("focus");
    }
    function x() {
      g = window.setTimeout(() => {
        a.value = !1, i == null || i.$emit("blur"), clearTimeout(g);
      }, 100);
    }
    K(() => {
      if (t.limit && E.value && Y(d.value, t.limit)) {
        const e = Z(d.value, t.limit);
        V.value = e + "px";
      }
    }), O(y, (e, o) => {
      w(e, o) || (l.value = [0, 0]);
    });
    function B(e) {
      const o = e.currentTarget;
      n("update:modelValue", o.value);
    }
    function T() {
      return t.suggestions && t.suggestions.length > 0;
    }
    function F(e, o) {
      const u = w([e, o], l.value);
      return u && U(), u;
    }
    function H() {
      m(
        t.suggestions[l.value[0]].items[l.value[1]],
        h.SuggestionEmitValueTypes.TAB
      ), x();
    }
    function m(e, o = h.SuggestionEmitValueTypes.CLICK) {
      n("update:modelValue", e.text), n("select", {
        suggestionItem: e,
        type: o
      });
    }
    function D() {
      let e = l.value[0], o = l.value[1];
      const u = t.suggestions.length - 1;
      o === 0 ? e - 1 >= 0 ? (e--, l.value = [e, t.suggestions[e].items.length - 1]) : l.value = [u, t.suggestions[u].items.length - 1] : l.value = [e, --o], b(l.value[0], l.value[1]);
    }
    function p() {
      let e = l.value[0], o = l.value[1];
      const u = t.suggestions.length;
      o === t.suggestions[e].items.length - 1 ? u - 1 >= e + 1 ? l.value = [++e, 0] : l.value = [0, 0] : l.value = [e, ++o], b(l.value[0], l.value[1]);
    }
    function b(e, o) {
      var I;
      const u = S.value.find(
        (k) => k.dataset.index === `${e},${o}`
      );
      (I = u == null ? void 0 : u.scrollIntoView) == null || I.call(u, {
        behavior: "smooth",
        block: "nearest"
      });
    }
    function L(e, o) {
      l.value = [e, o];
    }
    function U() {
      n("highlighted", t.suggestions[l.value[0]].items[l.value[1]]);
    }
    function $() {
      var e;
      m(
        t.suggestions[l.value[0]].items[l.value[1]],
        h.SuggestionEmitValueTypes.ENTER
      ), (e = c.value) == null || e.blur();
    }
    function N() {
      n("update:modelValue", "");
    }
    return {
      onClear: N,
      hasError: v,
      hasFocus: a,
      input: c,
      isFilled: A,
      onFocus: M,
      onBlur: x,
      showSuggestions: E,
      highlightNext: p,
      highlightPrevious: D,
      onEnter: $,
      hasSuggestions: T,
      isHighlighted: F,
      onSuggestionClick: m,
      setCurrentHighlighted: L,
      computedSuggestions: y,
      onTab: H,
      wrapper: d,
      heightLimit: V,
      onModelUpdate: B,
      uid: s,
      suggestionsItems: S
    };
  }
});
function Y(t, n) {
  let i = 0;
  return t && Array.from(t.children).forEach((s) => i += s.childElementCount), i > n;
}
function Z(t, n) {
  if (!t)
    return 0;
  let i = 0, s = t == null ? void 0 : t.firstElementChild, g = s.offsetTop * 2;
  for (; i <= n && s; )
    Array.from(s.children).forEach((a) => {
      i < n && (g += a.offsetHeight), a.dataset.testId === "suggestion" && i++;
    }), s = s.nextElementSibling;
  return g;
}
export {
  ne as default
};
